"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserSubscriptionMetadata = exports.isCancellationReason = exports.isSubscriptionStatusUnion = exports.UserFacingWeeklyCoachingSubscriptionSchema = exports.UserSubscriptionSchema = exports.UserSubscriptionMetadataSchema = exports.SubscriptionStatusUnionSchema = exports.CancellationReasonSchema = void 0;
const zod_1 = require("zod");
const typing_utils_1 = require("../typing_utils");
const language_codes_types_1 = require("./language_codes_types");
const weekly_coaching_types_1 = require("./weekly_coaching_types");
// CONSTS
const cancellationReasons = [
    "user_cancelled",
    "billing_issue",
    "replaced",
    "revoked",
    "other",
];
const subscriptionStatuses = [
    "auto_renewing",
    "future",
    "paused",
    "cancelled",
];
// SCHEMAS
exports.CancellationReasonSchema = zod_1.z.union(typing_utils_1.mapArrayToLiteralTuple(cancellationReasons));
exports.SubscriptionStatusUnionSchema = zod_1.z.union(typing_utils_1.mapArrayToLiteralTuple(subscriptionStatuses));
// Update to tuple if we need to have
// more subscriptions with metadata
exports.UserSubscriptionMetadataSchema = weekly_coaching_types_1.WeeklyCoachingSubscriptionMetadataSchema;
exports.UserSubscriptionSchema = zod_1.z.object({
    cancellationReason: exports.CancellationReasonSchema.optional(),
    cancelledAt: zod_1.z.string().optional(),
    expiresAt: zod_1.z.string().optional(),
    id: zod_1.z.string(),
    isAmex: zod_1.z.boolean().optional(),
    metadata: exports.UserSubscriptionMetadataSchema.optional(),
    nextBillingAmount: zod_1.z.number().optional(),
    nextBillingAt: zod_1.z.string().optional(),
    overdueAmount: zod_1.z.number().optional(),
    planId: zod_1.z.string(),
    providerToken: zod_1.z.string().optional(),
    startedAt: zod_1.z.string().optional(),
    status: exports.SubscriptionStatusUnionSchema,
    userId: zod_1.z.string(),
});
exports.UserFacingWeeklyCoachingSubscriptionSchema = zod_1.z.object({
    expiresAt: zod_1.z.string().optional(),
    id: zod_1.z.string(),
    langPairCode: language_codes_types_1.LanguagePairCodeSchema,
    nextBillingAmount: zod_1.z.number().optional(),
    nextBillingAt: zod_1.z.string().optional(),
    planId: zod_1.z.string(),
    status: exports.SubscriptionStatusUnionSchema,
});
// TYPE GUARDS
const isSubscriptionStatusUnion = (v) => exports.SubscriptionStatusUnionSchema.safeParse(v).success;
exports.isSubscriptionStatusUnion = isSubscriptionStatusUnion;
const isCancellationReason = (v) => exports.CancellationReasonSchema.safeParse(v).success;
exports.isCancellationReason = isCancellationReason;
const isUserSubscriptionMetadata = (v) => exports.UserSubscriptionMetadataSchema.safeParse(v).success;
exports.isUserSubscriptionMetadata = isUserSubscriptionMetadata;
//# sourceMappingURL=user_subscriptions_types.js.map